// Example for LibraryAdmin page
export const dashboardTourSteps = [
  {
    target: '#tour-header-logo', // Tag input field
    content: 'Welcome to the SmartDog Portal Tour!',
  },
  {
    target: '#tour-burger', // Tag input field
    content: 'Short on space? Minimise the Left Menu Bar!',
  },
  {
    target: '#tour-notifications', // Tag input field
    content: 'Easy access to all your portal notifications!',
  },
  {
    target: '#tour-profile', // Tag input field
    content: 'Your portal quick links',
  },
  {
    target: '#tour-sidebar-dashboard', // CSS selector for the element
    content: 'Navigate al the features of the portal here!',
  },
  {
    target: '#tour-welcome', // Tag input field
    content: 'Portal welcome message',
  },

  {
    target: '#dashboardPerks', // CSS selector for the element
    content:
      'Statistical overview of your profile - # of dogs, # of questions and # of favourited items.',
  },
  {
    target: '#tour-social', // Tag input field
    content: 'Post a message, view users messages..',
  },
  {
    target: '#tour-dogs', // CSS selector for the element
    content:
      "Show's your dogs registered on the portal. Show's the completion % of your dogs profile - remember the more information provided the better SmartDog can better your user experience.",
  },
  {
    target: '#tour-notifications-site', // Tag input field
    content: 'Another show of your portal notifications and actions',
  },
];
